var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V21.8868H14.3958V0H0ZM13.815 21.306H11.7975V15.1295H8.25521V21.306H0.580798V0.580795H13.815V21.306Z",
    fill: "#C45AF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24406 2.06067V9.10934H6.36717V2.06067H2.24406ZM5.78638 8.52674H2.82486V2.64147H5.78638V8.52674Z",
    fill: "#C45AF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24406 10.5892V17.636H6.36717V10.5892H2.24406ZM5.78638 17.0552H2.82486V11.17H5.78638V17.0552Z",
    fill: "#C45AF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96573 2.06067V5.8745H12.0888V2.06067H7.96573ZM11.508 5.29371H8.54653V2.64147H11.508V5.29371Z",
    fill: "#C45AF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96573 7.3562V11.17H12.0888V7.3562H7.96573ZM11.508 10.5874H8.54653V7.937H11.508V10.5874Z",
    fill: "#C45AF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.5c3efb28d00faf5b314fae9d91c4b49a.svg";
export { ForwardRef as ReactComponent };